import { Route, Routes } from 'react-router-dom';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import { SignUpPage, SignUpVcfcPage, SuccessPage } from '@pages';

export const Public = () => {
  return (
    <Routes>
      {PaletteUtils.isInsigniaPalette && <Route path={RoutePaths.signup.path} element={<SignUpPage />} />}
      {PaletteUtils.isVcfcPalette && <Route path={RoutePaths.signup.path} element={<SignUpVcfcPage />} />}
      <Route path={RoutePaths.success.path} element={<SuccessPage />} />
    </Routes>
  );
};
